import React from 'react';
import classNames from 'classnames';
import styles from './table-row.module.scss';

type Props = { children: React.ReactNode; className: string; rowIndex: number };

export const TableRow: React.FC<Props> = ({ children, className, rowIndex }) => {
  return (
    <div aria-rowindex={rowIndex} className={classNames(styles.root, className)} role="row">
      {children}
    </div>
  );
};
